import { IHttpClient } from '~/packages/core';
import { EligibilityCheckerResult } from './types';

export class EligibilityAdapter {
    protected readonly httpClient: IHttpClient;

    constructor(httpClient: IHttpClient) {
        this.httpClient = httpClient;
    }

    checkEligibility(feature: string, check: string) {
        return this.httpClient.request<EligibilityCheckerResult>({
            method: 'get',
            url: `/api/v2/eligibility/${feature}`,
            params: {
                check
            }
        });
    }
}
